module.exports = __webpack_public_path__ + "img/logo_int.6ecd2c40.svg";